module.exports = __webpack_public_path__ + "img/megaphone.856f685d.svg";